module.exports = __webpack_public_path__ + "img/webapp-move-pro.0134c59c.png";